import * as yup from "yup";

const deleteSchema = (translate: Function) => yup.object().shape({
	efa016Descricao: yup.string().required(translate("Descrição do item não confere")).oneOf([yup.ref("efa016DescricaoConfirmation")], translate("Descrição do item não confere"))
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	eftba016 : yup.object().shape({
		efa016Codigo: yup.string().required(translate("Código é requerido")),
		efa016Descricao: yup.string().required(translate("Descrição é requerida")),
		efa016Ativo: yup.boolean()
	})
});

export { deleteSchema, addAndChangeSchema };
